import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Alert,
    AlertTitle
} from "@mui/material";
import outWardService from "../../../../services/outWardService";
import invoiceService from '../../../../services/invoicesService';
import ecommercePlaceService from "../../../../services/ecommercePlaceService";

import { useDispatch, useSelector } from 'react-redux';
import {
    Backdrop,
    Box,
    CircularProgress,
    Modal,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    Paper,
    Typography,
    Pagination,
    Stack,
    TextField,
    Button,
    Select,
    MenuItem,
    Chip,
    Divider
} from "@mui/material";
import { styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import PendingIcon from '@mui/icons-material/Pending';
import InfoIcon from '@mui/icons-material/Info';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { fetchInvoice } from '../../../../redux/actions/InvoicesActions';
import marketplacesService from "../../../../services/marketplacesService";
// Özel stiller tanımlama
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    borderRadius: '12px',
    boxShadow: '0 6px 16px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
    border: '1px solid rgba(224, 224, 224, 0.5)',
}));



export const InvoiceSendMarketPlaces = ({ openDialog, handleCloseDialog, data }) => {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState({});
    const [invoiceStatusList, setInvoiceStatusList] = useState(null);
    const userId = useSelector((state) => state?.auth?.user?.id);
    const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
    const [ecommerceAccounts, setEcommerceAllAccounts] = useState([]);
    const [marketpleacesAccounts, setMarketpleacesAllAccounts] = useState([]);
    useEffect(() => {

        const fetchAccounts = async () => {
            setLoading(true);

            try {
                const response = await marketplacesService.getMarketPlacesAccountsApi(
                    userId,
                    token
                );

                setMarketpleacesAllAccounts(response?.data?.data?.data);
                console.log("response?.data?.data?.data",response?.data?.data?.data);
                const uniqueMarketPlaceNames = [...new Set(response?.data?.data?.data.map(item => item?.marketPlaceName))];
                setAccountMarketpleacesName(uniqueMarketPlaceNames);
                setLoading(false);
            } catch (err) {
                console.log("err",err);
                setStatus({
                    success: false,
                    message: err.response?.data?.message || "Hesap bilgileri alınırken hata oluştu."
                });
                setLoading(false);
            }

        };

        const fetchAccountsEcommerce = async () => {
            setLoading(true);

            try {
                const response = await ecommercePlaceService.getEcommercePlaceAccountsApi(
                    userId,
                    token
                );
                setEcommerceAllAccounts(response?.data?.data?.data);
                setLoading(false);
            } catch (err) {
                setStatus({
                    success: false,
                    message: err.response?.data?.message || "Hesap bilgileri alınırken hata oluştu."
                });

                setLoading(false);
            }

        };
        fetchAccounts();
        fetchAccountsEcommerce();
    }, [userId]);

    const createRequestBodyAttribute = () => {
        const marketPlaceSettings = marketpleacesAccounts
            .filter(account => account.marketPlaceName === data?.order?.marketPlace?.name)
            .map(account => ({
                id: 0,
                userId: account.userId,
                marketPlaceId: account.marketPlaceId || 0,
                marketPlaceName: account.marketPlaceName,
                valueId: account.valueId,
                value: account.value,
                createDate: new Date().toISOString(),
                updateDate: new Date().toISOString(),
                ia: true,
            }));

        const ecommercePlaceSettings = ecommerceAccounts
            .filter(account => account.ecommercePlaceName
                === data?.order?.ecommercePlace?.name)
            .map(account => ({
                id: 0,
                userId: account.userId,
                ecommercePlaceId: account.ecommercePlaceId || 0,
                ecommercePlaceName: account.ecommercePlaceName,
                valueId: account.valueId,
                value: account.value,
                createDate: new Date().toISOString(),
                updateDate: new Date().toISOString(),
                ia: true,
            }));
        return {
            invoiceLink: data?.link,
            invoiceıd: data?.id,
            shipmentPackageId: data?.order?.orderId,
            invoiceDateTime: data?.invoiceLines[0]?.createDate,
            invoiceNumber: data?.number,
            orderNumber: data?.order.orderNumber,
            marketPlaceSetting: marketPlaceSettings,
            ecommercePlaceSettings: ecommercePlaceSettings,
            packageNumbers: data?.order?.orderLines?.map(line => line.packageNumber).filter(Boolean) || []
        };
    };
    const dispatch = useDispatch();
    const authUserId = useSelector((state) => state?.auth?.user?.id);
    const sendInvoiceMarketPlaces = async () => {
        if (data?.link == null) {
            return;
        }

        if (loading) {
            return;
        }
        setLoading(true);

        if (data?.Link) {
            setStatus({
                success: false,
                message: 'Fatura işlemi daha tamamlanmadı.'
            });

        } else {

            const request = createRequestBodyAttribute()
            try {
                var response = await outWardService.sendInvoiceMarketplace(request, data?.order?.marketPlace?.name||data?.order?.ecommercePlace?.name);
                setInvoiceStatusList(response?.data?.data)
                if (response?.state==1) {
                    setStatus({
                        success: true,
                        message: 'Fatura aktarma işlemi başarılı'
                    });
                } else {
                    setStatus({
                        success: false,
                        message: response?.message||"Bir hata oluştu"
                    });
                }
                if (authUserId) {
                    dispatch(fetchInvoice(authUserId, 1, 10));
                }

            } catch (error) {
                setStatus({
                    success: false,
                    message: error.message || 'Fatura aktarma işlemi başarısız oldu'
                });
            } finally {
                setLoading(false);
            }
        }
        setLoading(false);


    };

    useEffect(() => {
        if (!openDialog) {
            setLoading(false);
        }
        else {
            sendInvoiceMarketPlaces();
        }
      
    }, [openDialog]);
    return (
        <Box>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        overflow: 'hidden'
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1
                    }}
                >
                    <ReceiptIcon />
                    Pazaryerleri Fatura Aktarma Durumu
                </DialogTitle>
                <DialogContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: 200,
                        p: 3,
                        maxHeight: '80vh',
                        overflow: 'hidden'
                    }}
                >
                    {data?.link == null?
                     <Alert severity="info">
                     Fatura aktarma işlemini gerçekleştirdiyseniz, "Fatura Durumu" alanından süreci takip edebilirsiniz. Fatura linkinizin oluşmasını bekleyin.
                   </Alert>:  loading ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <CircularProgress sx={{ mb: 2 }} />
                                <Typography variant="body1">
                                    Fatura aktarılıyor, lütfen bekleyin...
                                </Typography>
                            </Box>
                        ) : status ? (
                            <Alert
                                severity={status.success ? "success" : "error"}
                                sx={{ width: '100%', borderRadius: '8px' }}
                                variant="filled"
                            >
                                <AlertTitle>
                                    {status.success ? "Başarılı" : "Hata"}
                                </AlertTitle>
                                {status.message}
                            </Alert>
                        ) : null
                    }
                  
                </DialogContent>
            </Dialog>
        </Box>
    );
}

export default InvoiceSendMarketPlaces;